import { apiClient } from "helpers/api_helper";

export const getAllMaterialTypeData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/MaterialType/GetAllMaterialType`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getMaterialTypeSelectList = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/MaterialType/GetMaterialTypeSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
export const getOptionsSelectList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetConsumerOfferMetaData`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getMaterialTypeDetialsById = async (id: any) => {
    try {
        const response = await apiClient.get(`api/v1/MaterialType/GetMaterialTypeDetailsById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createMaterialType = async (data: object) => {
    try {
        const response = await apiClient.post('api/v1/MaterialType/InsertMaterialType', data);
        return response;
    } catch(error: any) {
        throw new Error(error.message);
    }
};

export const updateMaterialType = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/MaterialType/UpdateMaterialType', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteMaterialType = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/MaterialType/DeleteMaterialType?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};